import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from '../utils/axios';

const SiteMap = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            const { data } = await axios.get('/categories/tree');
            setCategories(data.data || []);
        } catch (error) {
            console.error('Kategoriler yüklenemedi', error);
        } finally {
            setLoading(false);
        }
    };

    const sectionLinkClass = "block text-gray-600 hover:text-primary transition-colors py-1";
    const subLinkClass = "block text-gray-500 hover:text-primary transition-colors py-1 text-sm ml-4";
    const sectionTitleClass = "font-serif text-xl text-gray-900 mb-4 pb-2 border-b border-gray-100";

    if (loading) {
        return (
            <div className="min-h-screen bg-white flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
            </div>
        );
    }

    return (
        <div className="min-h-screen bg-white">
            <div className="max-w-6xl mx-auto px-6 lg:px-12 py-20">
                <h1 className="font-serif text-4xl md:text-5xl font-light tracking-wide text-center mb-16">
                    Site Haritası
                </h1>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">

                    {/* Kurumsal */}
                    <div>
                        <h2 className={sectionTitleClass}>Kurumsal</h2>
                        <div className="space-y-1">
                            <Link to="/about" className={sectionLinkClass}>Hakkımızda</Link>
                            <Link to="/contact" className={sectionLinkClass}>İletişim</Link>
                            <Link to="/diamond-exchange" className={sectionLinkClass}>Pırlanta Değişim</Link>
                            <Link to="/quality-environment-policy" className={sectionLinkClass}>Kalite ve Çevre Politikası</Link>
                            <Link to="/compliance-policy" className={sectionLinkClass}>Uyum Politikası</Link>
                            <Link to="/information-society-services" className={sectionLinkClass}>Bilgi Toplumu Hizmetleri</Link>
                        </div>
                    </div>

                    {/* Kategoriler (Dinamik) */}
                    <div>
                        <h2 className={sectionTitleClass}>Kategoriler</h2>
                        <div className="space-y-4">
                            {categories.map((cat) => (
                                <div key={cat._id}>
                                    <Link
                                        to={`/products?category=${cat.slug}`}
                                        className="font-medium text-gray-800 hover:text-primary block mb-1"
                                    >
                                        {cat.name}
                                    </Link>
                                    {cat.subcategories && cat.subcategories.length > 0 && (
                                        <div className="ml-3 border-l-2 border-gray-100 pl-3">
                                            {cat.subcategories.map((sub) => (
                                                <Link
                                                    key={sub._id}
                                                    to={`/products?category=${sub.slug}`}
                                                    className="block text-sm text-gray-500 hover:text-primary py-1"
                                                >
                                                    {sub.name}
                                                </Link>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                            <div className="pt-2">
                                <Link to="/products" className="font-medium text-primary hover:text-primary-dark">Tüm Ürünler</Link>
                            </div>
                        </div>
                    </div>

                    {/* Müşteri Hizmetleri */}
                    <div>
                        <h2 className={sectionTitleClass}>Müşteri Hizmetleri</h2>
                        <div className="space-y-1">
                            <Link to="/faq" className={sectionLinkClass}>Sıkça Sorulan Sorular</Link>
                            <Link to="/ring-size-guide" className={sectionLinkClass}>Yüzük Ölçüsü Nasıl Alınır?</Link>
                            <Link to="/shipping" className={sectionLinkClass}>Teslimat Bilgileri</Link>
                            <Link to="/returns" className={sectionLinkClass}>İade ve Değişim</Link>
                            <Link to="/order-tracking" className={sectionLinkClass}>Sipariş Takibi</Link>
                            <Link to="/payment-options" className={sectionLinkClass}>Ödeme Seçenekleri</Link>
                            <Link to="/transaction-guide" className={sectionLinkClass}>İşlem Rehberi</Link>
                        </div>
                    </div>

                    {/* Yasal & Hesabım */}
                    <div className="space-y-10">
                        <div>
                            <h2 className={sectionTitleClass}>Yasal</h2>
                            <div className="space-y-1">
                                <Link to="/privacy" className={sectionLinkClass}>Gizlilik Politikası</Link>
                                <Link to="/terms" className={sectionLinkClass}>Kullanım Koşulları</Link>
                                <Link to="/kvkk" className={sectionLinkClass}>KVKK Aydınlatma Metni</Link>
                                <Link to="/cookie-policy" className={sectionLinkClass}>Çerez Politikası</Link>
                                <Link to="/distance-sales-agreement" className={sectionLinkClass}>Mesafeli Satış Sözleşmesi</Link>
                                <Link to="/privacy-security" className={sectionLinkClass}>Gizlilik ve Güvenlik</Link>
                            </div>
                        </div>

                        <div>
                            <h2 className={sectionTitleClass}>Hesabım</h2>
                            <div className="space-y-1">
                                <Link to="/login" className={sectionLinkClass}>Giriş Yap</Link>
                                <Link to="/register" className={sectionLinkClass}>Üye Ol</Link>
                                <Link to="/cart" className={sectionLinkClass}>Sepetim</Link>
                                <Link to="/wishlist" className={sectionLinkClass}>Favorilerim</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default SiteMap;
